import React, { useContext } from 'react'

import { InAppCommsContext } from 'modules/in_app_comms/store/InAppCommsProvider'

import InAppCommunication from './InAppCommunication'

/**
 * Renders in-app comm banners in the layout's banner slot (e.g. FactorialOneLayout)
 * so they shrink the content area instead of pushing the whole page down.
 * Must be rendered inside InAppCommsProvider.
 */
export const InAppCommsBannerSlot: React.FC = () => {
  const context = useContext(InAppCommsContext)
  if (!context) return null

  const bannerComms = context.activeComms.filter((comm) => comm.type === 'banner')

  return (
    <>
      {bannerComms.map(({ id, type, content, name }) => (
        <InAppCommunication
          key={id}
          component={{ id, type, content, name }}
          onDismiss={context.dismiss}
        />
      ))}
    </>
  )
}
